import { exportTableToCSVInternal } from './utils/exportTableToCSV.js'
import { fetchAllDataInternal } from './utils/fetchAllData.js'
import { renderTableInternal } from './utils/renderTable.js'
import { setLoadingState } from './utils/setLoadingState.js'
import {
  clearAndHideSubSectionDropdown,
  handleSectionChange,
  populateSectionDropdownForWebsite,
  populateWebsiteDropdown,
  resetFilter,
} from './utils/translationDashboardDropdownHelpers.js'
import { getTranslationDashboardElements } from './utils/translationDashboardElements.js'
import dropdownConfig from './utils/translationDashboardOptions.json'
import { buildLocaleHeaders, getAuthorUrl, getPage, initTranslationDashboardDropdowns, resetSorting } from './utils/utils.js'
window.locales = ['DE', 'ES', 'FR', 'FR-CA', 'IT', 'JA', 'PT_BR', 'SV', 'ZH', 'PL']

const PRODUCT_SOLUTIONS = 'products-and-solutions'
let currentPage = 1
let isFetchingData = false
let currentData = [] // store all fetched data for CSV export
let pageSize = 10
let orderBy = ''
let orderType = ''
let totalCount = 0

document.addEventListener('DOMContentLoaded', () => {
  const { websiteSelect, sectionSelect, buSelect, itemsPerPageSelect, searchButton, searchWrapper, searchInput, sortButtons } =
    getTranslationDashboardElements()

  // Initialize dropdown options from JSON configuration
  if (websiteSelect) {
    populateWebsiteDropdown(websiteSelect)
    const selectedWebsite = websiteSelect.value || (dropdownConfig.websites && dropdownConfig.websites[0] && dropdownConfig.websites[0].value)
    if (selectedWebsite) {
      populateSectionDropdownForWebsite(selectedWebsite, false)
    }
    clearAndHideSubSectionDropdown()
  }
  // Event listeners
  document.getElementById('previousPage').addEventListener('click', () => changePage('previous'))
  document.getElementById('nextPage').addEventListener('click', () => changePage('next'))
  const exportBtn = document.getElementById('exportCsvBtn')
  if (exportBtn) {
    exportBtn.addEventListener('click', () => {
      if (exportBtn.disabled) {
        return
      }
      exportTableToCSV()
    })
  }
  if (websiteSelect) {
    websiteSelect.addEventListener('change', () => {
      resetFilter()
      currentPage = 1
      const cleared = resetSorting()
      orderBy = cleared.orderBy
      orderType = cleared.orderType
      fetchAllData()
      // Re-init dropdowns so newly created items are interactive
      initTranslationDashboardDropdowns()
    })
  }
  sectionSelect.addEventListener('change', e => {
    handleSectionChange(e.target, PRODUCT_SOLUTIONS)
    currentPage = 1
    const cleared = resetSorting()
    orderBy = cleared.orderBy
    orderType = cleared.orderType
    fetchAllData()
  })
  buSelect.addEventListener('change', () => {
    currentPage = 1
    const cleared = resetSorting()
    orderBy = cleared.orderBy
    orderType = cleared.orderType
    fetchAllData()
  })
  itemsPerPageSelect.addEventListener('change', () => {
    currentPage = 1
    pageSize = parseInt(itemsPerPageSelect.value, 10)
    fetchAllData()
  })
  const statusRadios = document.querySelectorAll('input[name="translate_status"]')
  if (statusRadios && statusRadios.length) {
    statusRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        currentPage = 1
        const cleared = resetSorting()
        orderBy = cleared.orderBy
        orderType = cleared.orderType
        fetchAllData()
      })
    })
  }
  if (searchButton) {
    searchButton.addEventListener('click', () => {
      currentPage = 1
      const cleared = resetSorting()
      orderBy = cleared.orderBy
      orderType = cleared.orderType
      fetchAllData()
    })
  }
  if (searchWrapper) {
    searchWrapper.addEventListener('click', event => {
      const target = event.target
      // Do not trigger search when user is clicking into the input field
      if (target instanceof HTMLInputElement && target.classList.contains('cmp-translation-search-input')) {
        return
      }
      currentPage = 1
      const cleared = resetSorting()
      orderBy = cleared.orderBy
      orderType = cleared.orderType
      fetchAllData()
    })
  }
  if (searchInput) {
    searchInput.addEventListener('keydown', event => {
      if (event.key === 'Enter') {
        event.preventDefault()
        currentPage = 1
        const cleared = resetSorting()
        orderBy = cleared.orderBy
        orderType = cleared.orderType
        fetchAllData()
      }
    })
  }
  if (sortButtons && sortButtons.length) {
    sortButtons.forEach(button => {
      button.addEventListener('click', () => {
        const column = button.getAttribute('data-column')
        const type = button.getAttribute('data-order-type')
        if (!column || !type) {
          return
        }
        orderBy = column
        orderType = type
        currentPage = 1
        fetchAllData()
      })
    })
  }
  // Build locale headers dynamically
  buildLocaleHeaders()

  // Initialize custom dropdowns (if present in markup)
  initTranslationDashboardDropdowns()

  // Initial data load on page load
  fetchAllData()
})

function fetchAllData() {
  return fetchAllDataInternal({
    PRODUCT_SOLUTIONS,
    isFetchingData,
    pageSize,
    sizeOverride: undefined,
    setIsFetchingData: value => {
      isFetchingData = value
      setLoadingState(value)
    },
    setCurrentData: data => {
      currentData = data
    },
    setTotalCount: value => {
      totalCount = value
    },
    orderBy,
    orderType,
    renderTable,
    page: currentPage,
  })
}

function fetchAllDataForExport() {
  return fetchAllDataInternal({
    PRODUCT_SOLUTIONS,
    isFetchingData,
    pageSize,
    sizeOverride: 'all',
    setIsFetchingData: value => {
      isFetchingData = value
      setLoadingState(value)
    },
    setCurrentData: data => {
      currentData = data
    },
    setTotalCount: undefined,
    orderBy,
    orderType,
    renderTable,
    page: 1,
    skipRender: true,
    skipRedirects: false, // Keep redirect data for complete CSV report (backend is optimized)
  })
}
function renderTable() {
  renderTableInternal({
    currentData,
    currentPage,
    pageSize,
    totalCount,
  })
}

function changePage(direction) {
  currentPage = getPage({ direction, currentPage, totalCount, pageSize })
  fetchAllData()
}
function exportTableToCSV() {
  exportTableToCSVInternal({
    fetchAllData: fetchAllDataForExport,
    isFetchingDataGetter: () => isFetchingData,
    getCurrentData: () => currentData,
    getAuthorUrl,
  })
}
